<template>
  <div class="gridBox">
    <div class="tabContro">
        <div class="tit">明细信息（1）</div>
        <div class="del">删除</div>
    </div>
    <van-grid column-num="2">
      <van-grid-item>
        <div class="item">
          <div class="title">费用承担部门</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">费用类型</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">开始日期</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">结束日期</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">报销金额</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">出行工具</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">始发地</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">目的地</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">票据类型</div>
          <van-cell is-link @click="showPopup">请选择</van-cell>
        </div>
      </van-grid-item>
      <van-grid-item>
        <div class="item">
          <div class="title">费用说明</div>
          <van-field v-model="value" placeholder="请输入" />
        </div>
      </van-grid-item>
    </van-grid>
    <div class="add noCopy" onbeforecopy='return false'>
        <van-button><svg-icon icon-class="add" style="margin-right:4px;"/>添加费用明细</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
    };
  },
  methods: {
    showPopup() {
      this.$emit("showPopup", "");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>